module.exports = __webpack_public_path__ + "static/media/SCHAALKLEURSTOF_00.e54395f7.png";